import { API_BASE_URL } from '../../services/api';

// Never infer credentials or attach the API token to a document URL.
export function resolveFileUrl(value, base = API_BASE_URL) {
  if (typeof value !== 'string') return null;
  const path = value.trim();
  if (!path || /^(null|undefined|false)$/i.test(path) || Array.from(path).some(char => char.charCodeAt(0) < 32 || char === String.fromCharCode(92))) return null;
  try {
    const origin = new URL(base, window.location.origin);
    const url = new URL(path, `${origin.href.replace(/\/$/, '')}/`);
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null;
    return url.href;
  } catch { return null; }
}

export function documentType(url, mime = '') {
  const extension = (new URL(url).pathname.match(/\.([a-z0-9]+)$/i)?.[1] || '').toLowerCase();
  if (/^(jpe?g|png|webp)$/.test(extension)) return 'image';
  if (extension === 'pdf') return 'pdf';
  if (/^docx?$/.test(extension)) return 'word';
  if (/^xlsx?$/.test(extension)) return 'spreadsheet';
  if (/^image\/(jpeg|png|webp)$/.test(mime)) return 'image';
  if (mime === 'application/pdf') return 'pdf';
  if (/word|officedocument.wordprocessingml/.test(mime)) return 'word';
  if (/excel|spreadsheetml/.test(mime)) return 'spreadsheet';
  return 'file';
}

export function parseCertificateDate(value) {
  if (typeof value !== 'string' || !value.trim() || value.startsWith('0000-')) return null;
  const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ].*)?$/) || value.trim().match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/);
  if (!match) return null;
  const [year, month, day] = match[1].length === 4 ? match.slice(1).map(Number) : [Number(match[3]), Number(match[2]), Number(match[1])];
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}

export function formatCertificateDate(value) {
  const date = parseCertificateDate(value);
  return date ? new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }).format(date) : 'Not updated';
}

export function certificateStatus(value, now = new Date()) {
  const date = parseCertificateDate(value);
  if (!date) return { label: 'Unknown', color: 'default' };
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const limit = new Date(today); limit.setDate(limit.getDate() + 30);
  if (date < today) return { label: 'Expired', color: 'error' };
  if (date <= limit) return { label: 'Expiring Soon', color: 'warning' };
  return { label: 'Valid', color: 'success' };
}
